// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var _document_getElementById;
var getPortalRoot = function() {
    return "object" !== "undefined" && ((_document_getElementById = document.getElementById("portal-root")) !== null && _document_getElementById !== void 0 ? _document_getElementById : document.body);
};
export default getPortalRoot;
